import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const DoubleIntegralEvaluation = () => (
  <QPhototModuleSubtopic
    title="Evalution of double integral"
    videos={[
      "https://www.youtube.com/embed/NfAXZXZHovY"
    ]}
    takeaways={[
        {text:"If limits are in terms of x then integrate with dy and vice versa "}
    ]}
    questions={[
        {
            image:"/cal_41.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default DoubleIntegralEvaluation;
